import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container, Grid2, Box, Typography } from "@mui/material";
import { getConfig } from "../../config";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import "./ApplicationDetailsDSADetails.css";

function ApplicationDetailsDSADetails() {
  const [dsaASettingsURL, setDsaASettingsURL] = useState("");
  const [BusinessEntityName, setBusinessEntityName] = useState("");
  const [RegistrationNumber, setRegistrationNumber] = useState("");
  const [CountryofRegistration, setCountryofRegistration] = useState("");
  const [Email, setEmail] = useState("");
  const [ContactNumber, setContactNumber] = useState("");
  const [Address, setAddress] = useState("");
  const { submissionDetails } = useSelector((state) => state.submissionDetails);

  useEffect(() => {
    let firstUrl = getConfig().REACT_APP_REDIRECT_URI;
    firstUrl = firstUrl.replace("/applications", "/settings/dsa-complaint-url");
    const navigatingURL = `${firstUrl}`;
    setDsaASettingsURL(navigatingURL);
  }, []);

  useEffect(() => {
    if (submissionDetails) {
      const dsaInfo = submissionDetails.seller?.dsaInfo || {};
      setBusinessEntityName(dsaInfo.businessEntityName || "");
      setRegistrationNumber(dsaInfo.registrationNumber || "");
      setCountryofRegistration(dsaInfo.registrationCountry || "");
      setEmail(dsaInfo.email || "");
      setContactNumber(dsaInfo.phone || "");
      setAddress(
        `${dsaInfo?.address?.city || ""}, ${dsaInfo?.address?.state || ""}, ${
          dsaInfo?.address?.country || ""
        }, ${dsaInfo?.address?.postalCode || ""}`
      );
    }
  }, [submissionDetails]);

  const navigateToApplicationDetails = ($event) => {
    $event.stopPropagation();
    window.open(dsaASettingsURL, "_blank"); // Opens in new tab/window
  };

  return (
    <Container maxWidth="lg">
      <Grid2 container justifyContent="flex-start">
        <Grid2
          size={12}
          sx={{
            display: "flex !important",
          }}
        >
          <div
            style={{
              marginLeft: "10%",
            }}
          >
            <div>
              <p className="dsa-details-text">DSA Details</p>
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: 400,
                  fontSize: 14,
                  letterSpacing: "0px",
                  color: "#717273",
                  marginTop: "-20px",
                  marginBottom: "20px",
                }}
              >
                Business entity details of the app seller and complaint link
              </Typography>
            </div>
            <div style={{ display: "flex", gap: 40, marginBottom: 24 }}>
              <div>
                <div className="DSA-details-content-text">
                  Business Entity Name
                </div>
                <div className="DSA-details-content-details-text">
                  {BusinessEntityName}
                </div>
              </div>
              <div>
                <div
                  className="DSA-details-content-text"
                  style={{ whiteSpace: "nowrap" }}
                >
                  Registration Number
                </div>
                <div className="DSA-details-content-details-text">
                  {RegistrationNumber}
                </div>
              </div>
              <div>
                <div
                  className="DSA-details-content-text"
                  style={{ whiteSpace: "nowrap" }}
                >
                  Country of Registration
                </div>
                <div className="DSA-details-content-details-text">
                  {CountryofRegistration}
                </div>
              </div>
              <div>
                <div className="DSA-details-content-text">Email</div>
                <div className="DSA-details-content-details-text">{Email}</div>
              </div>
              <div>
                <div
                  className="DSA-details-content-text"
                  style={{ whiteSpace: "nowrap" }}
                >
                  Contact Number
                </div>
                <div className="DSA-details-content-details-text">
                  {ContactNumber}
                </div>
              </div>
            </div>
            <div style={{ marginBottom: "25px" }}>
              <div className="DSA-details-content-text">Address</div>
              <div className="DSA-details-content-details-text">{Address}</div>
            </div>
          </div>
        </Grid2>
        <div
          style={{
            marginLeft: "10%",
            marginBottom: 40,
            width: "100%",
            borderBottom: "1px solid rgba(18, 20, 21, 0.2)",
          }}
        >
          <Box sx={{ display: "flex" }}>
            <p className="dsa-compliance-report-link-text">
              DSA Compliance Report Link :
            </p>
            <p
              className="link-text-dsa-complaint"
              style={{
                marginLeft: 8,
                marginTop: "14px",
                cursor: "pointer",
                textDecoration: "none !important",
                color: "#2A2C2D !important",
                fontFamily: "Roboto",
                fontWeight: 600,
                fontStyle: "SemiBold",
                fontSize: 16,
                letterSpacing: 0,
              }}
            >
              <span data-testid="dsa-link">
                <a
                  href={dsaASettingsURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "#2A2C2D" }}
                  onClick={(e) => {
                    e.preventDefault();
                    navigateToApplicationDetails(e);
                  }}
                >
                  Manage URLs
                  <OpenInNewIcon
                    sx={{
                      marginBottom: "0px",
                      fontSize: "14px",
                      marginLeft: "4px",
                      color: "rgba(18, 20, 21, 0.6)",
                    }}
                  />
                </a>
              </span>
            </p>
          </Box>
        </div>
      </Grid2>
    </Container>
  );
}

export default ApplicationDetailsDSADetails;
